import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import Card from "./Card/Card.js"; // default экспорт!

import staffData from "../../Data/specialists/specialistsData.json";

export default function Employees() {
  const sliderRef = useRef(null);

  // Количество видимых карточек в зависимости от ширины экрана
  const getVisibleCards = () => {
    const width = window.innerWidth;
    if (width < 768) return 1;
    if (width < 1024) return 2;
    return 4;
  };

  const [visibleCards, setVisibleCards] = useState(getVisibleCards());

  useEffect(() => {
    const handleResize = () => setVisibleCards(getVisibleCards());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Автопрокрутка каждые 5 секунд
  useEffect(() => {
    const interval = setInterval(() => {
      sliderRef.current?.slickNext();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: visibleCards,
    autoplay: false,
  };

  return (
    <section className="employees">
      <div className="employees__description">
        <h2 className="employees__title">Наши сотрудники</h2>
      </div>

      <button
        className="prevention__left employees__left"
        onClick={() => sliderRef.current?.slickPrev()}
      ></button>
      <button
        className="prevention__right employees__right"
        onClick={() => sliderRef.current?.slickNext()}
      ></button>

      <div className="employees__slider">
        <Slider ref={sliderRef} {...settings}>
          {staffData.map((person) => (
            <Card
              key={person.id}
              name={person.name}
              description={person.position}
              abbreviated={person.abbreviated}
              image={person.photo}
              slug={person.slug}
            />
          ))}
        </Slider>
      </div>

      <h4 className="prevention__button employees__button">
        <a
          href="/patients/specialists"
          className="prevention__link employees__link"
        >
          Все специалисты
        </a>
      </h4>
    </section>
  );
}
